'use strict';

(function () {
  'use strict';

  angular.module('msActivityServices', ['msUtility', 'msCore', 'ngStorage']);
})();